import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./Banner.css";

const fadeUp = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7 } },
};

const fade = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.7 } },
};

const Banner = () => {
  const navigate = useNavigate();

  return (
    <section className="impact-banner" aria-label="Platform-friendly marketing">
      <div className="impact-blob one" aria-hidden="true" />
      <div className="impact-blob two" aria-hidden="true" />

      <div className="impact-wrap">
        <motion.div
          className="impact-left"
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.5 }}
        >
          <div className="impact-badge">
            <span className="dot" aria-hidden="true" />
            Ad-friendly pages
          </div>

          <h2 className="impact-title">
            Landing pages that <span>match your ads</span>.
          </h2>

          <p className="impact-sub">
            We help you present a clear business identity, honest offers, and easy paths to privacy terms and contact
            information—common expectations when running Google Ads and similar programs.
          </p>

          <ul className="impact-trust">
            <li>No hidden fees in ad copy</li>
            <li>Disclosures for endorsements &amp; affiliates</li>
            <li>Cookie/analytics described in privacy policy</li>
            <li>HTTPS and working contact methods</li>
          </ul>

          <div className="impact-actions">
            <button type="button" className="impact-btn primary" onClick={() => navigate("/privacy-policy")}>
              Privacy policy <span aria-hidden="true">→</span>
            </button>

            <button type="button" className="impact-btn secondary" onClick={() => navigate("/disclaimer")}>
              Disclaimer
            </button>
          </div>
        </motion.div>

        <motion.div
          className="impact-right"
          variants={fade}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.35 }}
        >
          <div className="impact-card">
            <div className="impact-cardTop">
              <div>
                <p className="impact-cardKicker">What we avoid promising</p>
                <h3 className="impact-cardTitle">Straight talk</h3>
              </div>
              <span className="impact-chip">Policy-aligned copy</span>
            </div>

            <ul className="impact-list impact-list--simple">
              <li>
                <i aria-hidden="true">✓</i> Guaranteed #1 rankings, fixed CPA, or “instant” viral results—we do not sell
                those claims.
              </li>
              <li>
                <i aria-hidden="true">✓</i> Misleading before/after metrics or fake urgency timers on core offers.
              </li>
              <li>
                <i aria-hidden="true">✓</i> Collecting data without a lawful basis described in your privacy notice.
              </li>
              <li>
                <i aria-hidden="true">✓</i> Impersonating platforms, celebrities, or other brands.
              </li>
            </ul>

            <p className="impact-foot">
              Platform policies change. Your ads, destinations, and data practices must stay accurate—review official
              Google Ads and network help centers alongside our work.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Banner;
